//src/components/shared/CrudRowActions.tsx
import { Eye, FileClock, KeyRound, Pencil, Power } from "lucide-react";

import { PermissionIconButton } from "@/components/shared/PermissionIconButton";

type CrudRowActionsProps = {
  onView?: () => void;
  onEdit?: () => void;
  onPassword?: () => void;
  onLogs?: () => void;
  onToggleActive?: () => void;
  isActive?: boolean;
  disabled?: boolean;

  viewPermission?: string | string[];
  editPermission?: string | string[];
  passwordPermission?: string | string[];
  logsPermission?: string | string[];
  toggleActivePermission?: string | string[];

  noPermissionLabel?: string;
};

function permissionProps(permission?: string | string[]) {
  return Array.isArray(permission)
    ? { permissions: permission }
    : { permission };
}

export function CrudRowActions({
  onView,
  onEdit,
  onPassword,
  onLogs,
  onToggleActive,
  isActive = true,
  disabled = false,
  viewPermission,
  editPermission,
  passwordPermission,
  logsPermission,
  toggleActivePermission,
  noPermissionLabel = "Você não possui permissão para esta ação",
}: CrudRowActionsProps) {
  return (
    <div className="flex items-center justify-end gap-1">
      {onView ? (
        <PermissionIconButton
          label="Visualizar"
          {...permissionProps(viewPermission)}
          disabled={disabled}
          noPermissionLabel={noPermissionLabel}
          onClick={onView}
        >
          <Eye className="h-4 w-4" />
        </PermissionIconButton>
      ) : null}

      {onEdit ? (
        <PermissionIconButton
          label="Editar"
          {...permissionProps(editPermission)}
          disabled={disabled}
          noPermissionLabel={noPermissionLabel}
          onClick={onEdit}
        >
          <Pencil className="h-4 w-4" />
        </PermissionIconButton>
      ) : null}

      {onPassword ? (
        <PermissionIconButton
          label="Alterar senha"
          {...permissionProps(passwordPermission)}
          disabled={disabled}
          noPermissionLabel={noPermissionLabel}
          onClick={onPassword}
        >
          <KeyRound className="h-4 w-4" />
        </PermissionIconButton>
      ) : null}

      {onLogs ? (
        <PermissionIconButton
          label="Logs"
          {...permissionProps(logsPermission)}
          disabled={disabled}
          noPermissionLabel={noPermissionLabel}
          onClick={onLogs}
        >
          <FileClock className="h-4 w-4" />
        </PermissionIconButton>
      ) : null}

      {onToggleActive ? (
        <PermissionIconButton
          label={isActive ? "Desativar" : "Ativar"}
          {...permissionProps(toggleActivePermission)}
          disabled={disabled}
          noPermissionLabel={noPermissionLabel}
          onClick={onToggleActive}
          destructive={isActive}
        >
          <Power className="h-4 w-4" />
        </PermissionIconButton>
      ) : null}
    </div>
  );
}
